import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Footer.css";

function Footer() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });
  }, []);

  return (
    <footer className="footer-section text-white mt-5">
      <div className="footer-overlay py-5">
        <div className="container">

          {/* Stats Row */}
          <div className="row text-center mb-5">
            <div className="col-md-4 mb-4" data-aos="fade-right">
              <h2 className="fw-bold text-success counter">5000+</h2>
              <p className="text-light">Shipments Delivered</p>
            </div>
            <div className="col-md-4 mb-4" data-aos="fade-up">
              <h2 className="fw-bold text-success counter">10,000+</h2>
              <p className="text-light">Happy Customers</p>
            </div>
            <div className="col-md-4 mb-4" data-aos="fade-left">
              <h2 className="fw-bold text-success counter">12+</h2>
              <p className="text-light">Branches Worldwide</p>
            </div>
          </div>

          {/* Footer Body */}
          <div className="row text-center text-md-start">

            {/* About */}
            <div className="col-md-4 mb-4" data-aos="fade-right">
              <h3 className="fw-bold mb-3 footer-title">
                <span>D</span><span className="text-danger">2</span>
                <span>D N<span className="text-danger">E</span>TWORK</span>
              </h3>
              <p className="small text-light">
                Delivering Trust, Connecting Worlds Since 2013.<br />
                Reliable international logistics partner from Tamil Nadu to the world.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-md-4 mb-4" data-aos="fade-up">
              <h5 className="fw-bold text-success mb-3">Quick Links</h5>
              <ul className="list-unstyled small">
                <li><a href="/" className="footer-link">Home</a></li>
                <li><a href="/#services" className="footer-link">Services</a></li>
                <li><a href="/about" className="footer-link">About Us</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-md-4 mb-4" data-aos="fade-left">
              <h5 className="fw-bold text-success mb-3">Contact Us:</h5>

              <div className="contact-box p-3 rounded-4 shadow-sm">
                <h6 className="fw-bold mb-2 d-flex align-items-center location-title">
                  <span className="me-2 fs-5">📍</span> Our Location
                </h6>

                <p className="small mb-3 lh-base text-location">
                  691/6C, Salem Main Road, Opp. ICICI Bank, <br />
                  Near Thiruveni Car Showroom, Elampillai – 637502, <br />
                  Tamil Nadu, India
                </p>

                <a
                  href="https://maps.google.com/?q=691/6c+salem+main+road+elampillai"
                  className="btn btn-sm rounded-pill shadow map-btn"
                  target="_blank"
                >
                  Open in Google Maps
                </a>
                <br />

                <a href="tel:+919363034349" className="footer-contact">
                  <i className="fas fa-phone"></i> +91 93630 34349
                </a>
                <br />
                <a href="tel:+914283796283" className="footer-contact">
                  <i className="fas fa-phone"></i> +91 42837 96283
                </a>

                <p className="small text-light mt-2">d2dgroup.elm@gmail.com</p>
              </div>
            </div>
          </div>

          {/* Social Icons Bottom Center */}
            <div className="social-footer text-center mt-4">
  <a href="https://youtube.com/@d2dexpresstpr?si=3tljkGGfMEW9nWBM" className="social-icon youtube">
    <i className="fab fa-youtube"></i>
  </a>
  <a href="https://www.facebook.com/share/1AEWyR85Zt/" className="social-icon">
    <i className="fab fa-facebook-f"></i>
  </a>
  <a href="https://wa.me/8124343494" className="social-icon">
    <i className="fab fa-whatsapp"></i>
  </a>
  <a href="https://www.instagram.com/dtodgroup" className="social-icon">
    <i className="fab fa-instagram"></i>
  </a>
</div>

        
          </div>

        </div>


      {/* Bottom Bar */}
      <div className="footer-bottom mt-4 pt-3 text-center">
        <p className="small mb-0 text-light">
          © {new Date().getFullYear()}{" "}
          <span>D2D Express</span> — All Rights Reserved. |  Powered by KaviVerse IT solutions
        </p>
      </div>
    </footer>
  );
}

export default Footer;
